<ng-container *transloco="let t">
  @if (variant() === 'loan-tasks') {
    <section
      [id]="elementIds.card"
      data-testid="share-screen-card"
      class="flex w-full flex-col gap-4 rounded-card border border-ld-neutral-200 bg-ld-neutral px-6 py-5 text-white"
      [attr.aria-label]="t('shareScreenCardAriaLabel')"
    >
      @if (isMobileDisplay()) {
        <div [id]="elementIds.header" class="flex items-center gap-4">
          <h3
            [id]="elementIds.title"
            data-testid="share-screen-card-title-mobile"
            class="font-poppins text-base font-medium leading-5 tracking-[0.04px] text-white"
          >
            {{ t('shareScreenCardNeedHelpTitle') }}
          </h3>
        </div>
        <p
          [id]="elementIds.description"
          data-testid="share-screen-card-description-mobile"
          class="font-dm text-sm font-medium leading-5 tracking-[0.14px] text-white"
        >
          {{ t(shareScreenCardDescriptionKey()) }}
        </p>
      } @else {
        <div [id]="elementIds.header" class="flex items-center gap-2">
          <ld-svg-icon
            [id]="elementIds.icon"
            [src]="communicationPhoneIcon"
            aria-hidden="true"
            class="size-4 shrink-0 text-white"
          />
          <h3
            [id]="elementIds.title"
            data-testid="share-screen-card-title-desktop"
            class="font-poppins text-xl font-medium leading-7 tracking-[0.05px] text-white"
          >
            {{ t('shareScreenCardOnCallTitle') }}
          </h3>
        </div>
        <p
          [id]="elementIds.description"
          data-testid="share-screen-card-description"
          class="font-dm text-sm font-normal leading-5 tracking-[0.14px] text-white"
        >
          {{ t(shareScreenCardDescriptionKey()) }}
        </p>
      }

      <button
        [id]="elementIds.button"
        data-testid="share-screen-card-button"
        type="button"
        [class]="shareScreenCardButtonClass()"
        [disabled]="isShareScreenLoading()"
        [class.opacity-60]="isShareScreenLoading()"
        [class.pointer-events-none]="isShareScreenLoading()"
        (click)="onShareScreenClick()"
      >
        @if (isShareScreenLoading()) {
          <mat-spinner
            [id]="elementIds.spinner"
            data-testid="share-screen-card-spinner"
            diameter="16"
            class="inline-block"
          />
        } @else {
          <ld-svg-icon
            [id]="elementIds.buttonIcon"
            [src]="heroiconScreenshareIcon"
            aria-hidden="true"
            class="size-4 shrink-0 text-ld-neutral-700"
          />
        }
        <span [id]="elementIds.buttonLabel" data-testid="share-screen-card-button-label">
          {{ t(shareScreenCardButtonKey()) }}
        </span>
      </button>
    </section>
  } @else {
    <section
      [id]="elementIds.card"
      data-testid="share-screen-card"
      class="flex w-full flex-col rounded-card border border-ld-neutral-200 bg-white text-ld-neutral-900 shadow-sm"
      [attr.aria-label]="t('shareScreenCardAriaLabel')"
    >
      <div [id]="elementIds.originationsSection" class="flex flex-col gap-4 px-8 pt-6 pb-4">
        <div [id]="elementIds.header" class="flex items-center gap-3">
          <ld-svg-icon [id]="elementIds.icon" [src]="customerSupportIcon" aria-hidden="true" class="size-8 shrink-0" />
          <h3
            [id]="elementIds.title"
            data-testid="share-screen-card-standard-title"
            class="font-dm text-xl font-semibold leading-7 text-ld-neutral-900"
          >
            {{ t('shareScreenCardStandardTitle') }}
          </h3>
        </div>

        <p
          [id]="elementIds.description"
          data-testid="share-screen-card-standard-description"
          class="font-dm text-sm leading-5 text-ld-neutral-700"
        >
          {{ t('shareScreenCardStandardDescription') }}
        </p>

        <div [id]="elementIds.phones" class="flex flex-col gap-2 font-dm text-sm leading-5">
          <span class="font-semibold text-ld-neutral-900">{{ t('shareScreenCardNewLoanLabel') }}</span>
          <a
            [id]="elementIds.originationsPhone"
            data-testid="share-screen-card-originations-phone"
            class="inline-flex items-center gap-2 cursor-pointer font-semibold text-ld-primary hover:text-ld-primary-700"
            [href]="originationSupportTel"
          >
            <ld-svg-icon [src]="phoneIcon" aria-hidden="true" class="size-4 shrink-0" />
            {{ originationSupportPhone }}
          </a>
        </div>
      </div>

      <div
        [id]="elementIds.servicingSection"
        class="flex flex-col gap-2 border-t border-ld-neutral-200 px-8 py-4 font-dm text-sm leading-5"
      >
        <span class="font-semibold text-ld-neutral-900">{{ t('shareScreenCardExistingLoanLabel') }}</span>
        <a
          [id]="elementIds.servicingPhone"
          data-testid="share-screen-card-servicing-phone"
          class="inline-flex items-center gap-2 cursor-pointer font-semibold text-ld-primary hover:text-ld-primary-700"
          [href]="servicingSupportTel"
        >
          <ld-svg-icon [src]="phoneIcon" aria-hidden="true" class="size-4 shrink-0" />
          {{ servicingSupportPhone }}
        </a>
      </div>

      <div
        [id]="elementIds.shareScreenSection"
        class="flex flex-col gap-4 border-t border-ld-neutral-200 px-8 pt-4 pb-6"
      >
        <p [id]="elementIds.prompt" class="flex flex-col gap-2 font-dm text-sm leading-5 text-ld-neutral-700">
          <span
            [id]="elementIds.promptTitle"
            data-testid="share-screen-card-standard-prompt-title"
            class="font-semibold text-ld-neutral-900"
          >
            {{ t('shareScreenCardStandardPromptTitle') }}
          </span>
          <span [id]="elementIds.promptDescription" data-testid="share-screen-card-standard-prompt-description">
            {{ t('shareScreenCardStandardPromptDescription') }}
          </span>
        </p>

        <button
          [id]="elementIds.button"
          data-testid="share-screen-card-button"
          type="button"
          [class]="shareScreenCardButtonClass()"
          [disabled]="isShareScreenLoading()"
          [class.opacity-60]="isShareScreenLoading()"
          [class.pointer-events-none]="isShareScreenLoading()"
          (click)="onShareScreenClick()"
        >
          @if (isShareScreenLoading()) {
            <mat-spinner
              [id]="elementIds.spinner"
              data-testid="share-screen-card-spinner"
              diameter="16"
              class="inline-block"
            />
          } @else {
            <ld-svg-icon
              [id]="elementIds.buttonIcon"
              [src]="heroiconScreenshareIcon"
              aria-hidden="true"
              class="size-4 shrink-0 text-ld-neutral-700"
            />
          }
          <span [id]="elementIds.buttonLabel" data-testid="share-screen-card-button-label">
            {{ t('shareScreenCardButton') }}
          </span>
        </button>
      </div>
    </section>
  }
</ng-container>
